import React, { useState } from 'react';
import { MessageCircle } from '@saleshandy/icons';
import { IntercomEvents } from '../../../../../shared/enums/intercom-events';
import { shouldHideIntercom } from '../../../../../shared/utils/user-details';

const ChatButton: React.FC = () => {
  const [isChatBeaconOpen, setIsChatBeaconOpen] = useState(false);


  if (shouldHideIntercom()) {
    return null;
  }

  const intercomHelperFunction = () => {
    if (window.Intercom && !isChatBeaconOpen) {
      window.Intercom(IntercomEvents.SHOW, IntercomEvents.ON_SHOW, () => {
        setIsChatBeaconOpen(true);
      });
    }
    if (window.Intercom && isChatBeaconOpen) {
      window.Intercom(IntercomEvents.HIDE, IntercomEvents.ON_HIDE, () => {
        setIsChatBeaconOpen(false);
      });
    }
  };

  const onIntercomScoutToggle = () => {
    setIsChatBeaconOpen(!isChatBeaconOpen);
    intercomHelperFunction();
  };

  if (window.Intercom) {
    window.Intercom(IntercomEvents.ON_SHOW, () => {
      setIsChatBeaconOpen(true);
    });
    window.Intercom(IntercomEvents.ON_HIDE, () => {
      setIsChatBeaconOpen(false);
    });
  }

  return (
    <button
      type="button"
      className="app-sidebar__nav-item-container chat-button"
      onClick={onIntercomScoutToggle}
    >
      <div className="app-sidebar__nav-item">
        <div className="nav-item-left">
          <div className="nav-item-icon">
            <MessageCircle />
          </div>
          <span className="nav-item-text">Need support?</span>
        </div>

        <div className="nav-item-right" />
      </div>
    </button>
  );
};

export default ChatButton;
